import { Deferred, Link } from '@inertiajs/react'
import { ArrowLeft } from 'lucide-react'
import type { ReactElement } from 'react'
import { Button } from '@/components/ui/button'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import OrganizationAuthConfigsSection from '@/frontend/pages/CommandCenter/Organizations/components/OrganizationAuthConfigsSection'
import OrganizationHeader from '@/frontend/pages/CommandCenter/Organizations/components/OrganizationHeader'
import PlansTable from '@/frontend/pages/CommandCenter/Organizations/components/PlansTable'
import StripeSection from '@/frontend/pages/CommandCenter/Organizations/components/StripeSection'
import SubscriptionsTable from '@/frontend/pages/CommandCenter/Organizations/components/SubscriptionsTable'
import type {
  OrganizationAuthConfigCopy,
  OrganizationAuthConfigs,
} from '@/frontend/pages/CommandCenter/Organizations/components/organizationAuthConfigTypes'
import type {
  BillingPlanRow,
  OrganizationDetail,
  StripeSummary,
  SubscriptionRow,
} from '@/frontend/pages/CommandCenter/Organizations/components/organizationDetailTypes'

interface Props {
  organization: OrganizationDetail
  stripe: StripeSummary
  plans: BillingPlanRow[]
  subscriptions: SubscriptionRow[]
  composioAuthConfigs?: OrganizationAuthConfigs
  composioAuthConfigCopy: OrganizationAuthConfigCopy
}

function Show({ organization, stripe, plans, subscriptions, composioAuthConfigs, composioAuthConfigCopy }: Props) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button asChild variant="ghost" size="sm" className="-ml-2">
          <Link href="/cc/organizations">
            <ArrowLeft className="h-4 w-4" />
            Organizações
          </Link>
        </Button>
      </div>
      <OrganizationHeader organization={organization} />
      <StripeSection organization={organization} stripe={stripe} />
      <Deferred
        data="composioAuthConfigs"
        fallback={<div className="h-32 animate-pulse rounded-lg border border-border bg-card" />}
      >
        {composioAuthConfigs ? (
          <OrganizationAuthConfigsSection
            organizationSlug={organization.slug}
            catalog={composioAuthConfigs}
            copy={composioAuthConfigCopy}
          />
        ) : <></>}
      </Deferred>
      <PlansTable plans={plans} />
      <SubscriptionsTable subscriptions={subscriptions} />
    </div>
  )
}

Show.layout = (page: ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>

export default Show
